import styled from 'styled-components';
import { Color } from '@figure/frontlib-gui';
import EqualHousingImage from 'shared/assets/images/equal-housing.svg';

const EqualHousing = styled.div`
  margin-top: 8px;
  font-size: 1rem;
  font-weight: 400;
  letter-spacing: 0.6px;
  color: ${Color.DARK_GREY};
  line-height: 13px;
  vertical-align: bottom;
  padding-left: 16px;
  background: url(${EqualHousingImage}) no-repeat left;
  background-size: 13px 9px;
`;

export default EqualHousing;
